import DOMPurify from 'dompurify';

const SanitizeHTMLString = (value?: string|null) => {

    return DOMPurify.sanitize(value || "",{ FORCE_BODY: true })

}

export default SanitizeHTMLString;
